import type { ReactNode } from 'react';

import styles from './states.module.css';

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className={styles.state}>
      <p className={styles.emptyTitle}>{title}</p>
      {children}
    </div>
  );
}
